import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';

@Component({
    selector: 'app-callback',
    imports: [CommonModule],
    templateUrl: './callback.component.html',
    styleUrl: './callback.component.scss'
})
export class CallbackComponent {
  private readonly authService = inject(AuthService);
  private readonly route = inject(ActivatedRoute);

  readonly message = signal('Finishing your sign-in and loading the protected shell...');

  async ngOnInit(): Promise<void> {
    try {
      await this.authService.completeBrowserCallback(this.route.snapshot.queryParamMap);
    } catch (error) {
      console.error('Unable to complete browser-auth callback recovery.', error);
      this.message.set('We could not complete sign-in. Returning to the public entry route.');
      await this.authService.logout();
    }
  }
}
